import { useState } from 'react';
import { eyeOffOutline, eyeOutline } from 'ionicons/icons';
import moment from 'jalali-moment';
import Swal from 'sweetalert2';

export const useForceUpdate = () => {
    const [value, setValue] = useState(0);
    return () => setValue(value => value + 1);
}
export const Durational = (start: any, end: any) => {
    start = moment(start);
    end = moment(end);
    let duration = moment.duration(end.diff(start));
    let hours = Math.floor(duration.asHours());
    let mins = duration.asMinutes() % 60;
    mins = Math.round(mins);
    if (hours === 0 && mins) {
        return mins + " دقیقه ";
    } else if (hours && mins === 0) {
        return hours + " ساعت ";
    } else if (hours === 0 && mins === 0) {
        return 0;
    } else {
        return hours + " ساعت و " + mins + " دقیقه ";
    }
}
export const FormatTime = (datetime: any, format: any) => {
    if (datetime && datetime.length && datetime.length === 28) {
        var time = datetime.substr(11, 5);
    } else {
        return datetime;
    }
    switch (format) {
        case format = 'hh:mm':
            return time;
        case format = 'HH:mm':
            return time;
        case format = 'HH:MM':
            return time;
    }
}
export const TimeFormat = (datetime: any) => {
    if (datetime && datetime.length && datetime.length === 28) {
        let time = datetime.substr(11, 5);
        return time;
    } else {
        return datetime;
    }
}
export const FormatDate = (datetime: any, format: any, locale = 'fa') => {
    let date = moment(datetime).locale(locale);
    return date.parseZone().format(format);
}
export const TranslateAgeCode = (code: any) => {
    let title = code;
    switch (code) {
        case 'INF':
            title = 'نوزاد';
            break;
        case 'CHD':
            title = 'کودک';
            break;
        case 'ADT':
            title = 'بزرگسال';
            break;
        default:
            title = code;
    }
    return title;
}
export const TranslateChildAgeCode = (code: any) => {
    let title = code;
    switch (code) {
        case 1:
            title = 'تا 1 سال';
            break;
        case 2:
            title = '1 تا 2 سال';
            break;
        case 3:
            title = '2 تا 3 سال';
            break;
        case 4:
            title = '3 تا 4 سال';
            break;
        case 5:
            title = '4 تا 5 سال';
            break;
        case 6:
            title = '5 تا 6 سال';
            break;
        case 7:
            title = '6 تا 7 سال';
            break;
        case 8:
            title = '7 تا 8 سال';
            break;
        case 9:
            title = '8 تا 9 سال';
            break;
        case 10:
            title = '9 تا 10 سال';
            break;
        case 11:
            title = '10 تا 11 سال';
            break;
        case 12:
            title = '11 تا 12 سال';
            break;
        default:
            title = code;
    }
    return title;
}
export const TranslateRange = (section: any, type: any, code = null) => {
    if (type === 'CHD') {
        if (section === 'hotel') {
            return TranslateChildAgeRange(code);
        } else {
            let from = moment(new Date()).subtract(12, 'years').format('YYYY-MM-DD');
            let to = moment(new Date()).subtract(2, 'years').format('YYYY-MM-DD');
            let fromJ = moment(new Date()).subtract(12, 'years').locale('fa').format('YYYY-MM-DD');
            let toJ = moment(new Date()).subtract(2, 'years').locale('fa').format('YYYY-MM-DD');
            return {
                from: from,
                to: to,
                label: ' از ' + moment(from).format('YYYY/MM/DD') + ' تا ' + moment(to).format('YYYY/MM/DD'),
                fromJ: fromJ,
                toJ: toJ,
                labelJ: ' از ' + moment(fromJ).locale('fa').format('YYYY/MM/DD') + ' تا ' + moment(toJ).locale('fa').format('YYYY/MM/DD')
            };
        }
    } else if (type === 'ADT') {
        let from = moment(new Date()).subtract(100, 'years').format('YYYY-MM-DD');
        let to = moment(new Date()).subtract(12, 'years').format('YYYY-MM-DD');
        let fromJ = moment(new Date()).subtract(100, 'years').locale('fa').format('YYYY-MM-DD');
        let toJ = moment(new Date()).subtract(12, 'years').locale('fa').format('YYYY-MM-DD');
        return {
            from: from,
            to: to,
            label: ' قبل از ' + moment(to).format('YYYY/MM/DD'),
            fromJ: fromJ,
            toJ: toJ,
            labelJ: ' قبل از ' + moment(toJ).locale('fa').format('YYYY/MM/DD'),
        };
    } else if (type === 'INF') {
        let from = moment(new Date()).subtract(2, 'years').format('YYYY-MM-DD');
        let to = moment(new Date()).format('YYYY-MM-DD');
        let fromJ = moment(new Date()).subtract(2, 'years').locale('fa').format('YYYY-MM-DD');
        let toJ = moment(new Date()).locale('fa').format('YYYY-MM-DD');
        return {
            from: from,
            to: to,
            label: ' بعد از ' + moment(from).format('YYYY/MM/DD'),
            fromJ: fromJ,
            toJ: toJ,
            labelJ: ' بعد از ' + moment(fromJ).locale('fa').format('YYYY/MM/DD'),
        };
    }
}
export const TranslateChildAgeRange = (code: any) => {
    let value = {
        from: '',
        to: '',
        label: '',
        fromJ: '',
        toJ: '',
        labelJ: ''
    } as any;
    let from, to;
    switch (code) {
        case 1:
            from = moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).format('YYYY-MM-DD');
            break;
        case 2:
            from = moment(new Date()).subtract(2, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD');
            break;
        case 3:
            from = moment(new Date()).subtract(3, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(2, 'years').format('YYYY-MM-DD');
            break;
        case 4:
            from = moment(new Date()).subtract(4, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(3, 'years').format('YYYY-MM-DD');
            break;
        case 5:
            from = moment(new Date()).subtract(5, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(4, 'years').format('YYYY-MM-DD');
            break;
        case 6:
            from = moment(new Date()).subtract(6, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(5, 'years').format('YYYY-MM-DD');
            break;
        case 7:
            from = moment(new Date()).subtract(7, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(6, 'years').format('YYYY-MM-DD');
            break;
        case 8:
            from = moment(new Date()).subtract(8, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(7, 'years').format('YYYY-MM-DD');
            break;
        case 9:
            from = moment(new Date()).subtract(9, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(8, 'years').format('YYYY-MM-DD');
            break;
        case 10:
            from = moment(new Date()).subtract(10, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(9, 'years').format('YYYY-MM-DD');
            break;
        case 11:
            from = moment(new Date()).subtract(11, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(10, 'years').format('YYYY-MM-DD');
            break;
        case 12:
            from = moment(new Date()).subtract(12, 'years').format('YYYY-MM-DD');
            to = moment(new Date()).subtract(11, 'years').format('YYYY-MM-DD');
            break;
    }
    value.from = from;
    value.to = to;
    value.label = ' از ' + moment(from).format('YYYY/MM/DD') + ' تا ' + moment(to).format('YYYY/MM/DD');
    value.fromJ = moment(from).locale('fa').format('YYYY-MM-DD');
    value.toJ = moment(to).locale('fa').format('YYYY-MM-DD');
    value.labelJ = ' از ' + moment(from).locale('fa').format('YYYY/MM/DD') + ' تا ' + moment(to).locale('fa').format('YYYY/MM/DD');
    return value;
}
export const TranslateUnit = (code: any) => {
    let title = code;
    switch (code) {
        case 'KG':
            title = 'کیلوگرم';
            break;
        case 'PC':
            title = 'چمدان';
            break;
        default:
            title = code;
    }
    return title;
}
export const BaggareFormat = (data: any) => {
    if (data) {
        let result_explode = data.split(',');
        let result: any;
        result = {
            type: result_explode[0],
            type_name: TranslateAgeCode(result_explode[0]),
            amount: result_explode[1],
            unit: result_explode[2],
            unit_name: TranslateUnit(result_explode[2])
        }
        return 'هر ' + result.type_name + ' ' + result.amount + ' ' + result.unit_name;
    } else {
        return;
    }
}
export const CleanHTML = (html: string) => {
    return <span dangerouslySetInnerHTML={{ __html: html }}></span>
}
interface Options {
    title?: string,
    text?: string,
    html?: string,
    icon?: any,
    iconHtml?: string,
    iconColor?: string,
    customClass?: {
        container: string
    },
    backdrop?: boolean,
    allowOutsideClick?: boolean,
    showConfirmButton?: boolean,
    showDenyButton?: boolean,
    confirmButtonText?: string,
    denyButtonText?: string,
    confirmButtonColor?: string,
    denyButtonColor?: string,
    isConfirmed?: any,
    isDenied?: any,
}
export const ShowSwal = (options: Options) => {
    Swal.fire({
        title: options.title,
        text: options.text,
        html: options.html,
        icon: options.icon,
        iconHtml: options.iconHtml,
        iconColor: options.iconColor,
        customClass: {
            container: options.customClass!.container
        },
        backdrop: options.backdrop,
        allowOutsideClick: options.allowOutsideClick,
        showConfirmButton: options.showConfirmButton,
        showDenyButton: options.showDenyButton,
        confirmButtonText: options.confirmButtonText,
        denyButtonText: options.denyButtonText,
        confirmButtonColor: options.confirmButtonColor,
        denyButtonColor: options.denyButtonColor,
    }).then((result) => {
        if (result.isConfirmed) {
            options.isConfirmed();
        } else if (result.isDenied) {
            options.isDenied();
        }
    })
}
export const AirlinesFlights = (arr: any, type: string) => {
    let list = [];
    if (type === 'went') {
        let airlinesNames = AirlinesFlightsNames(arr, type);
        for (let i = 0; i < arr.length; i++) {
            let index = list.findIndex(record => record.code === arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['operatingAirline']['code']);
            if (list && index === -1) {
                let item = {} as any;
                item.code = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['operatingAirline']['code'];
                item.name = airlinesNames[item.code];
                list.push(item);
            }
        }
    }
    if (type === 'return') {
        let airlinesNames = AirlinesFlightsNames(arr, type);
        for (let i = 0; i < arr.length; i++) {
            let index = list.findIndex(record => record.code === arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['operatingAirline']['code']);
            if (list && index === -1) {
                let item = {} as any;
                item.code = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['operatingAirline']['code'];
                item.name = airlinesNames[item.code];
                list.push(item);
            }
        }
    }
    return list;
}
export const AirlinesFlightsNames = (arr: any, type: string) => {
    let list = [];
    if (type === 'went') {
        for (let i = 0; i < arr.length; i++) {
            let airline_code = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['operatingAirline']['code'];
            let airline_name = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['operatingAirline']['companyShortName'];
            if (typeof arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['tpaextensions']['any'][0]['airlinePersian'] != undefined) {
                if (arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['tpaextensions']['any'][0]['airlinePersian']) {
                    airline_name = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['tpaextensions']['any'][0]['airlinePersian'];
                }
            }
            list[airline_code] = (airline_name);
        }
    }
    if (type === 'return') {
        for (let i = 0; i < arr.length; i++) {
            let airline_code = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['operatingAirline']['code'];
            let airline_name = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['operatingAirline']['companyShortName'];
            if (typeof arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['tpaextensions']['any'][0]['airlinePersian'] != undefined) {
                if (arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['tpaextensions']['any'][0]['airlinePersian']) {
                    airline_name = arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['tpaextensions']['any'][0]['airlinePersian'];
                }
            }
            list[airline_code] = (airline_name);
        }
    }
    return list;
}
export const StopsFlights = (arr: any, type: string) => {
    let list = [];
    if (type === 'went') {
        for (let i = 0; i < arr.length; i++) {
            if (list && list.indexOf((arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1)) === -1) {
                list.push((arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1));
            }
        }
    }
    if (type === 'return') {
        for (let i = 0; i < arr.length; i++) {
            if (list && list.indexOf((arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1)) === -1) {
                list.push((arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1));
            }
        }
    }
    return list;
}
export const MsToTime = (s = 0) => {
    let ms = s % 1000;
    s = (s - ms) / 1000;
    let secs = s % 60;
    s = (s - secs) / 60;
    let mins = s % 60;
    let hrs = (s - mins) / 60;
    return hrs + ' ساعت و ' + mins + ' دقیقه ';
}
export const MinutesToTime = (m: number) => {
    let hours = m / 60 | 0,
        minutes = m % 60 | 0;
    return hours + ' ساعت ' + (minutes !== 0 ? ' و ' + minutes + ' دقیقه ' : '');
}
export const DurationMinutes = (start: any, end: any) => {
    start = moment(start);
    end = moment(end);
    let minutes = 0;
    let duration = moment.duration(end.diff(start));
    minutes = duration.asMinutes();
    return minutes;
}
export const PriceFlightsLimit = (arr: any) => {
    let min, max;
    let response = {
        min: 0,
        max: 0
    }
    for (let i = 0; i < arr.length; i++) {
        if (!min || parseInt(arr[i]['airItineraryPricingInfo']['itinTotalFare'][0]['equivFare'][0]['amount']) < parseInt(min['airItineraryPricingInfo']['itinTotalFare'][0]['equivFare'][0]['amount']))
            min = arr[i];
    }
    response.min = parseInt(min['airItineraryPricingInfo']['itinTotalFare'][0]['equivFare'][0]['amount']);
    for (let i = 0; i < arr.length; i++) {
        if (!max || parseInt(arr[i]['airItineraryPricingInfo']['itinTotalFare'][0]['equivFare'][0]['amount']) > parseInt(max['airItineraryPricingInfo']['itinTotalFare'][0]['equivFare'][0]['amount']))
            max = arr[i];
    }
    response.max = parseInt(max['airItineraryPricingInfo']['itinTotalFare'][0]['equivFare'][0]['amount']);
    return response;
}
export const DurationFlightsLimit = (arr: any, type: string) => {
    let min, max;
    let response = {
        min: 0,
        max: 0
    }
    if (type === 'went') {
        for (let i = 0; i < arr.length; i++) {
            if (!min || DurationMinutes(arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['departureDateTime'], arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1]['arrivalDateTime']) < DurationMinutes(min['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['departureDateTime'], min['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][min['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1]['arrivalDateTime']))
                min = arr[i];
        }
        response.min = DurationMinutes(min['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['departureDateTime'], min['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][min['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1]['arrivalDateTime']);
        for (let i = 0; i < arr.length; i++) {
            if (!max || DurationMinutes(arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['departureDateTime'], arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1]['arrivalDateTime']) > DurationMinutes(max['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['departureDateTime'], max['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][max['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1]['arrivalDateTime']))
                max = arr[i];
        }
        response.max = DurationMinutes(max['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][0]['departureDateTime'], max['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'][max['airItinerary']['originDestinationOptions']['originDestinationOption'][0]['flightSegment'].length - 1]['arrivalDateTime']);
    }
    if (type === 'return') {
        for (let i = 0; i < arr.length; i++) {
            if (!min || DurationMinutes(arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['departureDateTime'], arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1]['arrivalDateTime']) < DurationMinutes(min['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['departureDateTime'], min['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][min['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1]['arrivalDateTime']))
                min = arr[i];
        }
        response.min = DurationMinutes(min['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['departureDateTime'], min['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][min['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1]['arrivalDateTime']);
        for (let i = 0; i < arr.length; i++) {
            if (!max || DurationMinutes(arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['departureDateTime'], arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][arr[i]['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1]['arrivalDateTime']) > DurationMinutes(max['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['departureDateTime'], max['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][max['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1]['arrivalDateTime']))
                max = arr[i];
        }
        response.max = DurationMinutes(max['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][0]['departureDateTime'], max['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'][max['airItinerary']['originDestinationOptions']['originDestinationOption'][1]['flightSegment'].length - 1]['arrivalDateTime']);
    }
    return response;
}
export const NumberToAlpha = (number: any) => {
    let title = '';
    switch (number) {
        case 1:
            title = 'اول';
            break;
        case 2:
            title = 'دوم';
            break;
        case 3:
            title = 'سوم';
            break;
        case 4:
            title = 'چهارم';
            break;
        case 5:
            title = 'پنجم';
            break;
        case 6:
            title = 'ششم';
            break;
        case 7:
            title = 'هفتم';
            break;
        case 8:
            title = 'هشتم';
            break;
        case 9:
            title = 'نهم';
            break;
        case 10:
            title = 'دهم';
            break;
        default:
            title = number;
    }
    return title;
};
export const PriceHotelsLimit = (arr: any) => {
    let min, max;
    let response = {
        min: 0,
        max: 0
    }
    for (let i = 0; i < arr.length; i++) {
        if (!min || parseInt(arr[i]['finalPrice']) < parseInt(min['finalPrice']))
            min = arr[i];
    }
    response.min = parseInt(min['finalPrice']);
    for (let i = 0; i < arr.length; i++) {
        if (!max || parseInt(arr[i]['finalPrice']) > parseInt(max['finalPrice']))
            max = arr[i];
    }
    response.max = parseInt(max['finalPrice']);
    return response;
}
export const HotelStars = (arr: any) => {
    let list = [];
    for (let i = 0; i < arr.length; i++) {
        if (parseFloat(arr[i]['basicPropertyInfo']['award'][0]['rating']) !== 0) {
            if (list && list.indexOf(parseFloat(arr[i]['basicPropertyInfo']['award'][0]['rating'])) === -1) {
                list.push(parseFloat(arr[i]['basicPropertyInfo']['award'][0]['rating']));
            }
        }
    }
    list.sort();
    return list;
}
export const CheckObject = (obj: any) => {
    if (obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype) {
        return true;
    } else {
        return false;
    }
}
export const ValidateEmail = (email: string) => {
    return String(email).toLowerCase().match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ) ? true : false;
}
export const ValidateIranMobile = (mobile: any) => {
    return mobile.match(/^(\+98|0|0098)?9\d{9}$/g) ? true : false;
}
export const ValidateEqualTo = (str1: string, str2: string) => {
    return str1 === str2;
}
export const ValidateOnlyEnglish = (value: any) => {
    return value.match(/^[a-zA-Z\s]*$/) ? true : false;
}
export const Countdown = (datetime: any) => {
    let timeLeft = '';
    let countDownDate = new Date(datetime).getTime();
    let now = new Date().getTime();
    let distance = countDownDate - now;
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (minutes) {
        timeLeft += minutes + " دقیقه ";
    }
    if (minutes && seconds) {
        timeLeft += " و ";
    }
    if (seconds) {
        timeLeft += seconds + " ثانیه ";
    }
    if (distance < 0) {
        return false;
    }
    return timeLeft;
}
export const TogglePassword = (pass: any, text: any, iconPass: any, iconText: any) => {
    const inputPass = document.getElementById(pass) as any;
    const inputText = document.getElementById(text) as any;
    const iconPassEl = document.getElementById(iconPass) as any;
    const iconTextEl = document.getElementById(iconText) as any;
    if (inputPass && inputText) {
        if (window.getComputedStyle(inputText).display === "none") {
            inputText.style.display = 'block';
            inputPass.style.display = 'none';
            iconTextEl.style.display = 'block';
            iconPassEl.style.display = 'none';
        } else {
            inputText.style.display = 'none';
            inputPass.style.display = 'block';
            iconTextEl.style.display = 'none';
            iconPassEl.style.display = 'block';
        }
    }
}
export const ToBase64 = (file: any) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});
export const MealPlans = (keyword: any) => {
    let title = keyword;
    switch (keyword) {
        case 'RO':
            title = "فقط اتاق";
            break;
        case 'FB':
            title = "صبحانه، ناهار، شام";
            break;
        case 'HB':
            title = "صبحانه، ناهار";
            break;
        case 'BB':
            title = "صبحانه";
            break;
        case 'AI':
            title = "صبحانه، ناهار، شام، پذيرايي تا ١٢ شب";
            break;
        case 'UI':
            title = "صبحانه، ناهار، شام، پذيرايي ٢٤ ساعته";
            break;
        case 'SC':
            title = "self catering";
            break;
        case 'AB':
            title = "as brochure";
            break;
        default:
            title = keyword;
    }
    return title;
}
export const FlightTripToCamelCase = (keyword: any) => {
    let value = keyword;
    switch (keyword) {
        case 'oneway':
            value = 'OneWay';
            break;
        case 'roundtrip':
            value = 'Roundtrip';
            break;
        case 'multiple':
            value = 'OneWay';
            break;
        default:
            value = keyword;
    }
    return value;
}
export const TranslateFlightRoutes = (code: any) => {
    let title = code;
    switch (code) {
        case 1:
            title = 'مسیر اول';
            break;
        case 2:
            title = 'مسیر دوم';
            break;
        case 3:
            title = 'مسیر سوم';
            break;
        case 4:
            title = 'مسیر چهارم';
            break;
        case 5:
            title = 'مسیر پنجم';
            break;
    }
    return title;
}
export const TranslateCabin = (keyword: string) => {
    let title = keyword;
    switch (keyword) {
        case 'Economy':
            title = 'اکونومی';
            break;
        case 'Business':
            title = 'بیزینس کلاس';
            break;
        case 'First':
            title = 'فرست کلاس';
            break;
        default:
            title = keyword;
    }
    return title;
}
export const ConvertToEnDigit = (str: any) => {
    return str
        .replace(/۰/g, '0')
        .replace(/۱/g, '1')
        .replace(/۲/g, '2')
        .replace(/۳/g, '3')
        .replace(/۴/g, '4')
        .replace(/۵/g, '5')
        .replace(/۶/g, '6')
        .replace(/۷/g, '7')
        .replace(/۸/g, '8')
        .replace(/۹/g, '9')
        .replace(/٠/g, '0')
        .replace(/١/g, '1')
        .replace(/٢/g, '2')
        .replace(/٣/g, '3')
        .replace(/٤/g, '4')
        .replace(/٥/g, '5')
        .replace(/٦/g, '6')
        .replace(/٧/g, '7')
        .replace(/٨/g, '8')
        .replace(/٩/g, '9');
}
export const GetMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor;
    if (/windows phone/i.test(userAgent)) {
        return "windows-phone";
    }
    if (/android/i.test(userAgent)) {
        return "android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return "ios";
    }
    return "unknown";
}